import React from 'react';
import Hero from '../components/Hero';
import SectionBlock from '../components/SectionBlock';
import FeaturedProperties from '../components/FeaturedProperties';
import GlobalBenchmark from '../components/GlobalBenchmark';
import { ArtOfRepresentation, LuxuryDivision, SportsEntertainmentDivision, LegacyDivision } from '../components/Divisions';
import { AsSeenIn } from '../components/AsSeenAndTiers';
import ExecutiveLeadership from '../components/ExecutiveLeadership';

export default function Home() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <Hero />

      <SectionBlock
        eyebrow="Featured"
        title="Luxury Real Estate. Redefined."
        description="A private collective for modern real estate advisors — where cinematic storytelling, elevated identity, and refined client experience shape the new standard in luxury representation."
        ctaLabel="Connect Privately →"
        ctaHref="/contact"
        variant="light"
      />

      <ArtOfRepresentation />

      <SectionBlock
        eyebrow="Featured"
        title="Principals"
        description={
          <p className="text-left">
            For founders, owners, brokers, and executive leaders who have already built something of consequence.
            The right architecture creates greater reach and capacity without sacrificing autonomy.
            Your identity stays yours. Your leadership remains central. Your brand is amplified, not absorbed.
            A private path forward that preserves authorship while creating the reach, capacity, and scale to
            carry what you&rsquo;ve built into its next chapter.
          </p>
        }
        ctaLabel="Inquire Privately →"
        ctaHref="/contact"
        variant="light"
      />

      <FeaturedProperties />

      <GlobalBenchmark />

      <LuxuryDivision />

      <AsSeenIn />

      <SportsEntertainmentDivision />

      <div id="collective">
        <ExecutiveLeadership />
      </div>

      <LegacyDivision />
    </>
  );
}
